<template>
  <div class="col-md-12 page pdf" :key="$route.fullPath">
    <div class="row file-upload-controls">
      <file-list
        :fileType="pdfFileType"
        :fileList="pdfList"
        @change="onPdfSelected"
        :selectedItem="selectedPdf"
        class="col-md-3 col-12"
      ></file-list>
      <file-upload :fileType="pdfFileType"></file-upload>
    </div>
    <!-- Not the same as a chart with no PDFs: the list itself could not be read
         (stores/chartPdfs.js), and an empty dropdown would say otherwise. -->
    <p v-if="pdfListLoadFailed" class="list-load-failed" role="alert" data-test="pdf-list-load-failed">
      This chart's PDFs could not be loaded. Reload the page to try again.
    </p>
    <div class="void-filler-pdf" v-if="selectedPdf === undefined">
      <h1 class="filler-header"><font-awesome-icon :icon="['fas', 'search-plus']" /></h1>
      <p>Select or upload a PDF to view its contents</p>
    </div>
    <pdf-content-body v-else :selectedPdf="selectedPdf" />
  </div>
</template>

<script>
import router from '@/router/index';
import { mapGetters } from 'vuex';
import { PDF_FILE_TYPE } from '@/config';
import FileListDropdown from '@/components/includes/file/FileListDropdown';
import FileUpload from '@/components/includes/file/FileUpload';
import PdfContentBody from '@/components/includes/pdf/PdfContentBody';
import { PdfsNavigation } from '@/store/modules/fsm/messages';

export default {
  name: 'pdfs-clinical-page',
  components: {
    'file-list': FileListDropdown,
    'file-upload': FileUpload,
    'pdf-content-body': PdfContentBody,
  },
  props: {
    selectedPdf: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      pdfFileType: PDF_FILE_TYPE,
    };
  },
  computed: {
    ...mapGetters('login/pdf', {
      pdfList: 'getPdfList',
      pdfListLoadFailed: 'pdfListLoadFailed',
    }),
  },
  methods: {
    onPdfSelected(selectedPdf) {
      router.push({
        name: PdfsNavigation,
        params: {
          selectedPdf,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  padding-top: 1rem;
}
.list-load-failed {
  color: #b00020;
  margin: 0.5rem 0 0;
}
.void-filler-pdf {
  color: gray;
  font-size: 1.5rem;
  text-align: center;
  margin-top: 2rem;

  .filler-header {
    font-size: 2.5rem;
    text-align: center;
  }
}
</style>
